import React, {memo} from "react";
import Label from "components/general/Label"
import { arraysEqual } from "helpers/utils";
import Esl from "components/common/Esl";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import useViewport from "components/general/useViewPort";
import Competitor from "components/presentation/Competitor";

export const TableExpandedIndividual = memo((props) => {  
    const { mirs_discipline } = useUrlFriendlyToParameters()  
    const {breakPoint} = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const {row, status} = props;
    const res = {
        hoop: row?.extendedResults?.find(er => er?.er_code === 'HOOP'),
        ball: row?.extendedResults?.find(er => er?.er_code === 'BALL'),
        clubs: row?.extendedResults?.find(er => er?.er_code === 'CLUBS'),
        ribbon: row?.extendedResults?.find(er => er?.er_code === 'RIBBON')
    }
    let penalty = false;    
    row?.extendedResults?.forEach(e => {
            if (e?.extensions?.find(ex => ex?.ere_code === 'PENALTY')) penalty = true;
    });

    let esl = row?.extCompetitor;
    const out = (<>
        <Esl data={esl} status={status}/>
        <table className={isMobile ? 'table-borderless ms-5' : 'table-borderless ms-5 w-80'}>
            <thead>
                <tr>
                    <th className="text-start"><Label data='HeaderScore' /></th>
                    <th className="text-end"><SportCode discipline={mirs_discipline} entity='@APPARATUS' code={'HOOP'} /></th>
                    <th className="text-end"><SportCode discipline={mirs_discipline} entity='@APPARATUS' code={'BALL'} /></th>
                    <th className="text-end"><SportCode discipline={mirs_discipline} entity='@APPARATUS' code={'CLUBS'} /></th>
                    <th className="text-end"><SportCode discipline={mirs_discipline} entity='@APPARATUS' code={'RIBBON'} /></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-start">{isMobile ? <>D</> : <Label data='HeaderDifficulty' />}</td>
                    <td className="text-end"><Points data={res?.hoop} code='DIFFICULTY' /></td>
                    <td className="text-end"><Points data={res?.ball} code='DIFFICULTY' /></td>
                    <td className="text-end"><Points data={res?.clubs} code='DIFFICULTY' /></td>
                    <td className="text-end"><Points data={res?.ribbon} code='DIFFICULTY' /></td>
                </tr>
                <tr>
                    <td className="text-start">{isMobile ? <>A</> : <Label data='HeaderArtistry' />}</td>
                    <td className="text-end"><Points data={res?.hoop} code='ARTISTIC' /></td>
                    <td className="text-end"><Points data={res?.ball} code='ARTISTIC' /></td>
                    <td className="text-end"><Points data={res?.clubs} code='ARTISTIC' /></td>
                    <td className="text-end"><Points data={res?.ribbon} code='ARTISTIC' /></td>
                </tr>
                <tr>
                    <td className="text-start">{isMobile ? <>E</> : <Label data='HeaderExecution' />}</td>
                    <td className="text-end"><Points data={res?.hoop} code='EXECUTION' /></td>
                    <td className="text-end"><Points data={res?.ball} code='EXECUTION' /></td>
                    <td className="text-end"><Points data={res?.clubs} code='EXECUTION' /></td>
                    <td className="text-end"><Points data={res?.ribbon} code='EXECUTION' /></td>
                </tr>
                { penalty &&
                <tr>
                    <td className="text-start">{isMobile ? <>P</> : <Label data='HeaderPenalty' />}</td>
                    <td className="text-end"><Points data={res?.hoop} code='PENALTY' /></td>
                    <td className="text-end"><Points data={res?.ball} code='PENALTY' /></td>
                    <td className="text-end"><Points data={res?.clubs} code='PENALTY' /></td>
                    <td className="text-end"><Points data={res?.ribbon} code='PENALTY' /></td>
                </tr>
                }
                <tr>
                    <td className="text-start"><Label data='HeaderTotal' /></td>
                    <td className="text-end"><Result data={res?.hoop} /></td>
                    <td className="text-end"><Result data={res?.ball} /></td>
                    <td className="text-end"><Result data={res?.clubs} /></td>
                    <td className="text-end"><Result data={res?.ribbon} /></td>
                </tr>
                <tr>
                    <td className="text-start"><Label data='HeaderRank' /></td>
                    <td className="text-end"><Rank data={res?.hoop} /></td>
                    <td className="text-end"><Rank data={res?.ball} /></td>
                    <td className="text-end"><Rank data={res?.clubs} /></td>
                    <td className="text-end"><Rank data={res?.ribbon} /></td>
                </tr>
            </tbody>
        </table>
    </>)

    return <>{out}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.row?.extendedResults, nextProps?.row?.extendedResults);
});


export const TableExpandedGroups = memo((props) => {  
    const { mirs_discipline } = useUrlFriendlyToParameters()  
    const {breakPoint} = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const {row, status} = props;
    const res = {
        hoop: row?.extendedResults?.find(er => er?.er_code === '5_HOOPS'),
        ribbon: row?.extendedResults?.find(er => er?.er_code === '3_RIBBONS_2_BALLS')
    }
    let penalty = false;    
    row?.extendedResults?.forEach(e => {
            if (e?.extensions?.find(ex => ex?.ere_code === 'PENALTY')) penalty = true;
    });

    let esl = row?.extCompetitor;
    const out = (<>
        <Esl data={esl} status={status}/>
        <table className={isMobile ? 'table-borderless' : 'table-borderless ms-5 w-80'}>
            <tbody>
                <tr>
                    <td className="align-top">
                        <table className="table-borderless">
                            <tbody>
                                <Athletes row={row} />
                            </tbody>
                        </table>
                    </td>
                    <td className="align-top">
                        <table className='table-borderless'>
                            <thead>
                                <tr>
                                    <th className="text-start"><Label data='HeaderScore' /></th>
                                    <th className="text-end"><SportCode discipline={mirs_discipline} entity='@APPARATUS' code={'5_HOOPS'} /></th>
                                    <th className="text-end"><SportCode discipline={mirs_discipline} entity='@APPARATUS' code={'3_RIBBONS_2_BALLS'} /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-start">{isMobile ? <>D</> : <Label data='HeaderDifficulty' />}</td>
                                    <td className="text-end"><Points data={res?.hoop} code='DIFFICULTY' /></td>
                                    <td className="text-end"><Points data={res?.ribbon} code='DIFFICULTY' /></td>
                                </tr>
                                <tr>
                                    <td className="text-start">{isMobile ? <>A</> : <Label data='HeaderArtistry' />}</td>
                                    <td className="text-end"><Points data={res?.hoop} code='ARTISTIC' /></td>
                                    <td className="text-end"><Points data={res?.ribbon} code='ARTISTIC' /></td>
                                </tr>
                                <tr>
                                    <td className="text-start">{isMobile ? <>E</> : <Label data='HeaderExecution' />}</td>
                                    <td className="text-end"><Points data={res?.hoop} code='EXECUTION' /></td>
                                    <td className="text-end"><Points data={res?.ribbon} code='EXECUTION' /></td>
                                </tr>
                                { penalty &&
                                <tr>
                                    <td className="text-start">{isMobile ? <>P</> : <Label data='HeaderPenalty' />}</td>
                                    <td className="text-end"><Points data={res?.hoop} code='PENALTY' /></td>
                                    <td className="text-end"><Points data={res?.ribbon} code='PENALTY' /></td>
                                </tr>
                                }
                                <tr>
                                    <td className="text-start"><Label data='HeaderTotal' /></td>
                                    <td className="text-end"><Result data={res?.hoop} /></td>
                                    <td className="text-end"><Result data={res?.ribbon} /></td>
                                </tr>
                                <tr>
                                    <td className="text-start"><Label data='HeaderRank' /></td>
                                    <td className="text-end"><Rank data={res?.hoop} /></td>
                                    <td className="text-end"><Rank data={res?.ribbon} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>

    </>)

    return <>{out}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.row?.extendedResults, nextProps?.row?.extendedResults);
});



const Points = ({data, code}) => {
    return  data?.extensions?.find(e => e?.ere_code === code)?.ere_value
}

const Result = ({data}) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()  
    return data?.er_irm ? <SportCode discipline={mirs_discipline} entity='@IRM' code={data?.er_irm} abbr={true} /> : data?.er_value ? <>{data?.er_value}</> : <></>;
}

const Rank = ({data}) => {
    return data?.er_rank && data?.er_rankequal ? `=${data?.er_rank}` : data?.er_rank ? data?.er_rank : '';
}

const Athletes = ({row}) => {
    if (!row?.teamAthletes || !Array.isArray(row.teamAthletes) || row.teamAthletes.length === 0) return ''
    row.teamAthletes.sort((a, b) => a?.order - b?.order);
    return row.teamAthletes.map(d => (<tr key={d?.order}><td><Competitor {...d.participantCode} hidePicture={true} hideNoc={true}/></td></tr>))
}


